import { styled } from "@mui/material/styles";
import { TableRow } from "@mui/material";
const StyledTableRow = styled(TableRow)(({ theme, isHeader, noColor, isBordered }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: noColor ? "#FFF" : "#F5F9FB",
    },
    '&:last-child td, &:last-child th': {
        border: 0,
        borderRight: isBordered ? "1px solid #0000001a" : ""
    },
    ...(isHeader && {
        // Styles for the header row
        '& td:first-child, & th:first-child': {
            borderTopLeftRadius: '26px',
            borderBottomLeftRadius: '26px',
        },
        '& td:last-child, & th:last-child': {
            borderTopRightRadius: '26px',
            borderBottomRightRadius: '26px',
            borderRight: "1px solid transparent"
        },
    }),
}));
export default StyledTableRow;
